export default function() {
    $('.accordion-expand').on('click', 'h3', function() {
        var $li = $(this).closest('li');
        $li.siblings().removeClass('active');
        $li.toggleClass('active');
    });

    // code aus main.js für altes faq Layout zum Anzeigen aller FAQs
    // $('.product-faq').on('click', '.more_faq_link', function(e) {
    //     e.preventDefault();
    //     $(this).addClass('hide');
    //     $('.more_faq').addClass('show');
    //     $(window).trigger('scroll');
    // });
};
